import RequestManager from "../../../requests/RequestManager";
import StagesTask from "../../../requests/tasks/sports/stagesTask";
import { getMatchData, getMatchesByJourney, getPhase2Config } from "../utils";
import logger from 'src/utils/logger/logger';

export default async function getMatches (idLeague, phaseId) {
    const isPhase2Enabled = getPhase2Config()
    const stagesTask = isPhase2Enabled ?
        new StagesTask(idLeague, phaseId) :
        new StagesTask(idLeague, phaseId, 'v1');
    try {
        const response = await RequestManager.addRequest(stagesTask);
        if(!response) return null;

        const navigation = (response.data && response.data.navigation) || null
        const subGroups = []
        const matchesPerGruop = {}

        response.data.rounds.forEach(round => {
            subGroups.push({
                id: round.roundCode,
                label: round.roundshortname && round.roundshortname !== null
                    ? round.roundshortname
                    :  phaseId === 'GROUP_STAGE' ? round.roundName.split(' ')[1] : round.roundName,
                roundLongName: (round.roundshortname && round.roundshortname !== null) || (phaseId === 'GROUP_STAGE') ? round.roundName : null,
            })
            if(phaseId === 'GROUP_STAGE') {
                matchesPerGruop[round.roundCode] = getMatchesByJourney(round.matches)
            }
            else {
                matchesPerGruop[round.roundCode] = round.matches.map(match => getMatchData(match))
            }
        });

        return {
            subGroups: subGroups.length > 1 ? subGroups : null,
            activeGroup: subGroups.length > 0 ? subGroups[0].id : null,
            matchesPerGroup: matchesPerGruop,
            navigation
        }
    } catch (error) {
        logger.error('Error fetching matches:', error);
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/services/getMatches.js